import React from 'react';
import { PriskSvg } from 'src/assets/dynamicSvg';
import { IconWizardSvg } from 'src/assets/dynamicSvg';
import { ActionText } from './styled';
import { QAItem } from './styled';
import wandIcon from 'src/assets/wand-icon.png';
import { Poppins } from 'src/common';

interface DefaultItemProps {
  readonly?: boolean;
}

export const ExecutiveSummaryItem: React.FC<DefaultItemProps> = () => {
  return (
    <QAItem data-cy="qa-exec-summary">
      <ActionText>+</ActionText>
      <ActionText>Executive Summary</ActionText>
    </QAItem>
  );
};

export const RiskToleranceItem: React.FC<DefaultItemProps> = () => {
  return (
    <QAItem data-cy="qa-risk">
      <ActionText>+</ActionText>
      <ActionText>Add Risk Tolerance</ActionText>
    </QAItem>
  );
};

export const ScenarioWizardItem: React.FC<DefaultItemProps> = () => {
  return (
    <QAItem data-cy="qa-scenario-wizard">
      <img src={wandIcon} alt="" />
      <ActionText>Scenario Wizard</ActionText>
    </QAItem>
  );
};

export const AssessmentVariablesItem: React.FC<DefaultItemProps> = () => {
  return (
    <QAItem data-cy="qa-variables">
      <IconWizardSvg />
      <ActionText>Assessment Variables</ActionText>
    </QAItem>
  );
};

export const SnapshotsItem: React.FC<DefaultItemProps> = () => {
  return (
    <QAItem data-cy="qa-snapshots">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
        <path
          d="M5.12602 8.07528C4.63948 8.07528 4.16386 7.931 3.75931 7.66069C3.35477 7.39038 3.03946 7.00618 2.85327 6.55668C2.66708 6.10717 2.61837 5.61255 2.71328 5.13535C2.8082 4.65816 3.0425 4.21983 3.38653 3.87579C3.73057 3.53175 4.1689 3.29746 4.6461 3.20254C5.12329 3.10762 5.61791 3.15634 6.06742 3.34253C6.51693 3.52872 6.90113 3.84403 7.17143 4.24857C7.44174 4.65312 7.58602 5.12873 7.58602 5.61528C7.58602 6.26771 7.32684 6.89342 6.8655 7.35476C6.40416 7.8161 5.77845 8.07528 5.12602 8.07528ZM5.12602 3.56527C4.72057 3.56527 4.32422 3.68551 3.9871 3.91076C3.64998 4.13602 3.38722 4.45619 3.23206 4.83077C3.0769 5.20536 3.03631 5.61755 3.11541 6.01521C3.19451 6.41287 3.38975 6.77815 3.67645 7.06485C3.96315 7.35154 4.32842 7.54679 4.72608 7.62589C5.12374 7.70499 5.53593 7.66439 5.91052 7.50923C6.28511 7.35407 6.60528 7.09132 6.83053 6.7542C7.05579 6.41707 7.17602 6.02073 7.17602 5.61528C7.17602 5.07158 6.96004 4.55016 6.57559 4.16571C6.19114 3.78126 5.66971 3.56527 5.12602 3.56527Z"
          fill="url(#paint0_linear_10016_1871)"
        />
        <path
          d="M6.55992 5.8201C6.50555 5.8201 6.45341 5.7985 6.41497 5.76006C6.37652 5.72161 6.35492 5.66947 6.35492 5.6151C6.35492 5.28888 6.22533 4.97603 5.99466 4.74536C5.76399 4.51469 5.45114 4.3851 5.12492 4.3851C5.07055 4.3851 5.01841 4.3635 4.97996 4.32505C4.94152 4.28661 4.91992 4.23447 4.91992 4.1801C4.91992 4.12573 4.94152 4.07359 4.97996 4.03514C5.01841 3.9967 5.07055 3.9751 5.12492 3.9751C5.55988 3.9751 5.97702 4.14788 6.28458 4.45544C6.59214 4.763 6.76492 5.18014 6.76492 5.6151C6.76492 5.66947 6.74333 5.72161 6.70488 5.76006C6.66644 5.7985 6.61429 5.8201 6.55992 5.8201Z"
          fill="url(#paint1_linear_10016_1871)"
        />
        <path
          d="M8.8152 4.1802C8.69356 4.1802 8.57466 4.14413 8.47352 4.07655C8.37238 4.00897 8.29356 3.91292 8.24701 3.80055C8.20046 3.68817 8.18828 3.56451 8.21201 3.44522C8.23574 3.32592 8.29432 3.21633 8.38033 3.13033C8.46633 3.04432 8.57592 2.98574 8.69522 2.96201C8.81451 2.93828 8.93817 2.95046 9.05055 2.99701C9.16292 3.04356 9.25897 3.12238 9.32655 3.22352C9.39413 3.32466 9.4302 3.44356 9.4302 3.5652C9.4302 3.7283 9.3654 3.88473 9.25007 4.00007C9.13473 4.1154 8.9783 4.1802 8.8152 4.1802ZM8.8152 3.3602C8.77465 3.3602 8.73502 3.37222 8.7013 3.39474C8.66759 3.41727 8.64132 3.44929 8.6258 3.48675C8.61028 3.5242 8.60622 3.56542 8.61413 3.60519C8.62204 3.64496 8.64157 3.68148 8.67024 3.71015C8.69891 3.73882 8.73544 3.75835 8.7752 3.76626C8.81497 3.77417 8.85619 3.77011 8.89365 3.75459C8.9311 3.73908 8.96312 3.7128 8.98565 3.67909C9.00817 3.64538 9.0202 3.60574 9.0202 3.5652C9.0202 3.51083 8.9986 3.45868 8.96015 3.42024C8.92171 3.38179 8.86957 3.3602 8.8152 3.3602Z"
          fill="url(#paint2_linear_10016_1871)"
        />
        <path
          d="M2.25531 1.72006H1.02531C0.970943 1.72006 0.918801 1.69846 0.880356 1.66002C0.841911 1.62157 0.820312 1.56943 0.820312 1.51506C0.820312 1.46069 0.841911 1.40855 0.880356 1.3701C0.918801 1.33166 0.970943 1.31006 1.02531 1.31006H2.25531C2.30968 1.31006 2.36183 1.33166 2.40027 1.3701C2.43872 1.40855 2.46031 1.46069 2.46031 1.51506C2.46031 1.56943 2.43872 1.62157 2.40027 1.66002C2.36183 1.69846 2.30968 1.72006 2.25531 1.72006Z"
          fill="url(#paint3_linear_10016_1871)"
        />
        <path
          d="M5.125 9.09991C4.42039 9.10022 3.73243 8.88568 3.1529 8.48491H1.025C0.753154 8.48491 0.492441 8.37692 0.300216 8.18469C0.107991 7.99247 0 7.73176 0 7.45991V3.15491C0 2.88306 0.107991 2.62235 0.300216 2.43012C0.492441 2.2379 0.753154 2.1299 1.025 2.1299H2.77365C2.88779 2.12975 2.99962 2.09783 3.09665 2.03773C3.19368 1.97763 3.27207 1.89172 3.32305 1.7896L3.59775 1.2402C3.64889 1.13778 3.7276 1.05165 3.82502 0.991534C3.92245 0.931413 4.03472 0.899679 4.1492 0.899904H6.1008C6.21529 0.899679 6.32756 0.931413 6.42498 0.991534C6.52241 1.05165 6.60112 1.13778 6.65226 1.2402L6.92696 1.7896C6.97793 1.89172 7.05632 1.97763 7.15335 2.03773C7.25038 2.09783 7.36222 2.12975 7.47636 2.1299H9.22501C9.49685 2.1299 9.75757 2.2379 9.94979 2.43012C10.142 2.62235 10.25 2.88306 10.25 3.15491V7.45991C10.25 7.73176 10.142 7.99247 9.94979 8.18469C9.75757 8.37692 9.49685 8.48491 9.22501 8.48491H7.09711C6.51757 8.88568 5.82962 9.10022 5.125 9.09991ZM1.025 2.5399C0.861892 2.5399 0.705465 2.6047 0.59013 2.72003C0.474795 2.83537 0.41 2.9918 0.41 3.15491V7.45991C0.41 7.62302 0.474795 7.77944 0.59013 7.89478C0.705465 8.01011 0.861892 8.07491 1.025 8.07491H3.2185C3.26123 8.07518 3.3028 8.0888 3.3374 8.11386C3.85815 8.48855 4.48347 8.69015 5.125 8.69015C5.76654 8.69015 6.39186 8.48855 6.91261 8.11386C6.94721 8.0888 6.98878 8.07518 7.03151 8.07491H9.22501C9.38811 8.07491 9.54454 8.01011 9.65988 7.89478C9.77521 7.77944 9.84001 7.62302 9.84001 7.45991V3.15491C9.84001 2.9918 9.77521 2.83537 9.65988 2.72003C9.54454 2.6047 9.38811 2.5399 9.22501 2.5399H7.47636C7.28616 2.5399 7.09972 2.48697 6.93788 2.38705C6.77605 2.28713 6.64521 2.14415 6.56 1.9741L6.2853 1.42265C6.26811 1.38853 6.24173 1.3599 6.20913 1.33998C6.17653 1.32005 6.13901 1.30964 6.1008 1.3099H4.1492C4.111 1.30964 4.07348 1.32005 4.04088 1.33998C4.00828 1.3599 3.98189 1.38853 3.9647 1.42265L3.69 1.9741C3.60479 2.14415 3.47396 2.28713 3.31212 2.38705C3.15029 2.48697 2.96385 2.5399 2.77365 2.5399H1.025Z"
          fill="url(#paint4_linear_10016_1871)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_10016_1871"
            x1="5.12602"
            y1="3.15527"
            x2="5.12602"
            y2="8.07528"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E62E61" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_10016_1871"
            x1="5.84242"
            y1="3.9751"
            x2="5.84242"
            y2="5.8201"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E62E61" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_10016_1871"
            x1="8.8152"
            y1="2.9502"
            x2="8.8152"
            y2="4.1802"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E62E61" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_10016_1871"
            x1="1.64031"
            y1="1.31006"
            x2="1.64031"
            y2="1.72006"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E62E61" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_10016_1871"
            x1="5.125"
            y1="0.899902"
            x2="5.125"
            y2="9.09991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E62E61" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
        </defs>
      </svg>
      <ActionText>Snapshots</ActionText>
    </QAItem>
  );
};

export const SandboxItem: React.FC<DefaultItemProps> = ({ readonly }) => {
  return (
    <QAItem data-cy="qa-sandbox">
      <PriskSvg />
      {readonly ? (
        <Poppins px={14} weight={500} color="cflowerBlue">
          Sandbox
        </Poppins>
      ) : (
        <ActionText>Sandbox</ActionText>
      )}
    </QAItem>
  );
};

export const EventActionItem = () => {
  return (
    <QAItem data-cy="qa-event-action">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path
          d="M10.565 1.63493H9.79201C9.4995 1.63493 9.26238 1.39781 9.26238 1.1053C9.26238 0.772383 8.98974 0.5 8.65651 0.5C8.32328 0.5 8.05063 0.772383 8.05063 1.1053C8.05063 1.39781 7.81351 1.63493 7.521 1.63493H5.21767C4.92516 1.63493 4.68804 1.39781 4.68804 1.1053C4.68804 0.772383 4.41539 0.5 4.08216 0.5C3.74893 0.5 3.47629 0.772383 3.47629 1.1053C3.47629 1.39781 3.23916 1.63493 2.94665 1.63493H2.17366C1.5072 1.63493 0.961914 2.1797 0.961914 2.84552V11.2894C0.961914 11.9552 1.5072 12.5 2.17366 12.5H10.5499C11.2163 12.5 11.7616 11.9552 11.7616 11.2894V2.84552C11.7768 2.1797 11.2315 1.63493 10.565 1.63493ZM10.5499 9.47427C10.5499 10.4684 9.74397 11.2743 8.74986 11.2743H3.97366C2.97955 11.2743 2.17366 10.4684 2.17366 9.47428V7.98979C2.17366 6.99567 2.97955 6.18979 3.97366 6.18979H8.74986C9.74397 6.18979 10.5499 6.99567 10.5499 7.98979V9.47427Z"
          fill="url(#paint0_linear_10557_4942)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_10557_4942"
            x1="0.961914"
            y1="0.5"
            x2="13.8091"
            y2="3.83985"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0001" stopColor="#E62E78" />
            <stop offset="1" stopColor="#FD5630" />
          </linearGradient>
        </defs>
      </svg>
      <ActionText>Comments</ActionText>
    </QAItem>
  );
};
